import React from 'react';
import { Icon, Text, View } from '@smarterservices/smarter-ui';
import { BlockComponentProps } from '../../types';

export interface IconBlock {
    type: 'icon';
    name: string;
    size?: 'x-small' | 'small' | 'medium' | 'large';
    align?: 'start' | 'end' | 'center' | 'inline';
    color?: 'primary' | 'secondary' | 'primary-inverse' | 'secondary-inverse' | 'success' | 'brand' | 'warning' | 'danger' | 'alert';
    margin?: string;
}

/**
 * IconBlock component renders an icon with optional color and alignment
 *
 * @param {BlockComponentProps<IconBlock>} props - Component props
 * @returns {React.ReactElement} Rendered icon
 */
export function IconBlock({ block }: BlockComponentProps<IconBlock>) {
    const { name, size = 'medium', align = 'inline', color, margin = 'none' } = block;

    const icon = <Icon name={name} size={size} />;

    // If color is specified, wrap the icon in a Text component
    if (color) {
        const textAlign = align === 'inline' ? undefined : align;

        return (
            <View
                as="div"
                margin={margin as any}
                textAlign={textAlign as any}
            >
                <Text color={color as any}>
                    {icon}
                </Text>
            </View>
        );
    }

    // Without color, render icon with alignment and margin
    if (align !== 'inline' || margin !== 'none') {
        return (
            <View
                as="div"
                margin={margin as any}
                textAlign={align === 'inline' ? undefined : (align as any)}
            >
                {icon}
            </View>
        );
    }

    return icon;
}

export default IconBlock;
